//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * Class used to compute the solar potential of a collection of roof sides
     */
    module.RoofSideCollection = function() {
        // Private attributes
        this._params = undefined;
        this._properties = {};
        this._roofSides = [];
    };

    /**
     * Class constructor
     * @constructor
     *
     * @param {Object} params - Object configuration. The following keys are required:
     *      - surfaceUsageCoefficient: [0-1] Maximum percentage of a roof surface area on which solar panels can be 
     *          installed
     *
     */
    module.RoofSideCollection.prototype.init = function(params) {
        this._params = params;
    };

    /**
     * Class destructor
     */
    module.RoofSideCollection.prototype.destroy = function() {
        this._params = undefined;
        this._roofSides = [];
    };

    module.RoofSideCollection.prototype.getMaxIrradiationOverArea = function(area) {
        if (this._roofSides.length == 0) {
            throw new Error("Cannot compute the maximum irradiation of the specified area: no roof sides have been selected");
        }

        for (var iRoofside = 0, nRoofsides = this._roofSides.length; iRoofside < nRoofsides; ++iRoofside) {
            var currRoofSide = this._roofSides[iRoofside];
            var availableArea = currRoofSide.surfaceArea * this._params.surfaceUsageCoefficient;
            if (availableArea > area) {
                return currRoofSide.annualSolarIrradiation * area;
            }
        }

        return this._properties.meanSpecificAnnualSolarEnergy * area;
    };

    module.RoofSideCollection.prototype.setRoofInfos = function(roofSideInfos) {
        if (roofSideInfos.length == 0) {
            throw new Error("Cannot compute the roof properties: no roof sides have been selected");
        }
        // Compute the total roof surface area, mean roof orientation and mean roof slope
        var firstRoofSide = roofSideInfos[0];
        var totalRoofSurfaceArea = firstRoofSide.surfaceArea;
        var meanRoofOrientation = firstRoofSide.orientation;
        var meanRoofSlope = firstRoofSide.slope;
        var buildingSurfaceArea = firstRoofSide.buildingGroundArea;

        for (var iRoofside = 1, nRoofsides = roofSideInfos.length; iRoofside < nRoofsides; ++iRoofside) {
            var currRoofSide = roofSideInfos[iRoofside];
            totalRoofSurfaceArea += currRoofSide.surfaceArea;
            if (currRoofSide.slope != undefined && Math.abs(currRoofSide.slope - meanRoofSlope) > 1.) {
                meanRoofSlope = undefined;
            }
            if (meanRoofOrientation != undefined) {
                var diff = Math.abs(currRoofSide.orientation - meanRoofOrientation);
                if (diff > 1. && diff < 359.) {
                    meanRoofOrientation = undefined;
                }
            }
        }

        this._properties.buildingGroundArea = buildingGroundArea;
        this._properties.totalRoofSurfaceArea = totalRoofSurfaceArea;
        this._properties.meanRoofOrientation = meanRoofOrientation;
        this._properties.meanRoofSlope = meanRoofSlope;

        // Compute the available surface area
        this._properties.maxAvailableRoof3DArea = totalRoofSurfaceArea * this._params.surfaceUsageCoefficient;

        // Sort the roof sides according to the value of their annual solar irradiation (descending order)
        roofSideInfos.sort(function(a, b) {
            return (a.annualSolarIrradiationInPlane < b.annualSolarIrradiationInPlane) ? 1 : -1;
        });
        this._roofSides = roofSideInfos; // Store information about the roof sides
    };

    module.RoofSideCollection.prototype.computeAnnualIrradiation = function(userInfos) {
        // Compute the annual total incoming solar energy (in kWh)
        var alreadyUsedArea = 0;
        this._properties.totalAnnualSolarEnergy = 0;
        for (var iRoofside = 0, nRoofsides = this._roofSides.length; iRoofside < nRoofsides; ++iRoofside) {
            var currRoofSide = this._roofSides[iRoofside];
            var potentiallyUsedArea = currRoofSide.surfaceArea * this._params.surfaceUsageCoefficient;
            if (alreadyUsedArea + potentiallyUsedArea > userInfos.usedRoofArea) {
                var effectivelyUsedArea = userInfos.usedRoofArea - alreadyUsedArea;
                this._properties.totalAnnualSolarEnergy += effectivelyUsedArea * currRoofSide.annualSolarIrradiationInPlane;
                break;
            } else {
                this._properties.totalAnnualSolarEnergy += potentiallyUsedArea * currRoofSide.annualSolarIrradiationInPlane;
            }
            alreadyUsedArea += potentiallyUsedArea;
        }

        // Compute the annual specific incoming solar energy (in kWh/m2)
        this._properties.meanSpecificAnnualSolarEnergy = this._properties.totalAnnualSolarEnergy / userInfos.usedRoofArea;
    };

    /**
     * Returns the specified roof property
     *
     * @param {String} - Name of the property to be returned
     * @param {Number|String} - Value of the requested property
     */
    module.RoofSideCollection.prototype.getProperty = function(property) {
        return this._properties[property];
    };

    /**
     * @return {Objet} - Roof properties. This object has the following keys:
     *      - totalAnnualSolarEnergy: [kWh]
     *      - meanSpecificAnnualSolarEnergy: [kWh/m2]
     *      - maxAvailableRoof3DArea: [m2]
     *      - usedSurfaceArea: [m2]
     *      - totalRoofSurfaceArea: [m2]
     *      - meanRoofOrientation: [deg]
     *      - meanRoofSlope: [deg]
     */
    module.RoofSideCollection.prototype.getProperties = function() {
        return this._properties;
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.RoofSideCollection
     *
     * @param {Object} params - Object configuration (see constructor of class am.RoofSideCollection for more information)
     * @return {am.RoofSideCollection} - New instance of class am.RoofSideCollection 
     */
    module.roofSideCollection = function(params) {
        var model = new am.RoofSideCollection();
        model.init(params);
        return model;
    };

    return module;

})(am.utils || {});